import type { Components, CssVarsTheme } from '@mui/material/styles';

const styleOverrides: NonNullable<
  Components<CssVarsTheme>['MuiPopover']
>['styleOverrides'] = {
  root: ({ theme }) => ({
    boxShadow: theme.shadows[6],
    '.MuiPopover-paper': {
      boxShadow: theme.shadows[6],
    },
  }),
};

const MuiPopover: Components<CssVarsTheme>['MuiPopover'] = {
  styleOverrides,
};

export default MuiPopover;
